<script lang="ts">
    import inputfields from "./"
    interface Props extends StepComponentProps {
        field: OfferAssistantField
    }
    let {
        ftpAssetsUrl,
        currentChoices = null,
        value = $bindable(),
        values = $bindable(),
        field,
        onInvalidConfig,
    }: Props = $props()
    const SvelteComponent = inputfields[field.widget as keyof typeof inputfields] || inputfields.default
</script>

<SvelteComponent
    {...field}
    {values}
    bind:value={value[field.name]}
    {currentChoices}
    onInvalidConfig={(b: boolean) => {
        onInvalidConfig(b)
    }}
    {ftpAssetsUrl}
/>
